import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["artsvpOption", "manualOption", "artsvpSection", "manualSection"]
  static values = { method: { type: String, default: "" } }

  connect() {
    this.updateView()
  }

  selectArtsvp(event) {
    event.preventDefault()
    this.methodValue = "artsvp"
    this.updateView()
  }

  selectManual(event) {
    event.preventDefault()
    this.methodValue = "manual"
    this.updateView()
  }

  updateView() {
    const isArtsvp = this.methodValue === "artsvp"
    const isManual = this.methodValue === "manual"

    this.updateOptionStyles(this.artsvpOptionTarget, isArtsvp)
    this.updateOptionStyles(this.manualOptionTarget, isManual)

    if (isArtsvp) {
      this.artsvpSectionTarget.classList.remove("hidden")
      this.manualSectionTarget.classList.add("hidden")
      return
    }

    if (isManual) {
      this.artsvpSectionTarget.classList.add("hidden")
      this.manualSectionTarget.classList.remove("hidden")
      return
    }

    this.artsvpSectionTarget.classList.add("hidden")
    this.manualSectionTarget.classList.add("hidden")
  }

  updateOptionStyles(option, selected) {
    option.classList.toggle("border-stone-900", selected)
    option.classList.toggle("bg-stone-50", selected)
    option.classList.toggle("shadow-md", selected)
    option.classList.toggle("ring-2", selected)
    option.classList.toggle("ring-stone-900/10", selected)
    option.classList.toggle("border-stone-200", !selected)
    option.classList.toggle("bg-white", !selected)
    option.setAttribute("aria-pressed", String(selected))
  }
}
